import { render } from "./quantity-ticker.component.vue?vue&type=template&id=b5de31fa&scoped=true&ts=true"
import script from "./quantity-ticker.component.vue?vue&type=script&lang=ts"
export * from "./quantity-ticker.component.vue?vue&type=script&lang=ts"

import "./quantity-ticker.component.vue?vue&type=style&index=0&id=b5de31fa&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5de31fa"]])

export default __exports__